import React, { useEffect } from 'react';
import { Card, Typography, Stack, Chip, Box, CircularProgress, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getTaskOverviewRequest } from './../../store/appActions';

export default function ProjectOverviewCard() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const taskData = useSelector((state) => state.app.taskoverview || []);

  useEffect(() => {
    dispatch(getTaskOverviewRequest());
  }, [dispatch]);
  
  const totalTasks = taskData.totalTasks ?? 0;
  const pendingTasks = taskData.pendingTasks ?? 0;
  const completedTasks = taskData.completedTasks ?? 0;

  const completionPercent = totalTasks
    ? Math.round((completedTasks / totalTasks) * 100)
    : 0;

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="h6"
        fontWeight={theme.typography.fontWeightBold}
        fontFamily={theme.typography.fontFamily}
        color={theme.palette.text.primary}
        mb={2}
      >
        Task Overview
      </Typography>

      <Stack direction="row" spacing={2} mb={3}>
        <Chip
          label={`Total: ${totalTasks.toLocaleString()}`}
          sx={{
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 500,
            fontFamily: theme.typography.fontFamily,
          }}
        />
        <Chip
          label={`Pending: ${pendingTasks.toLocaleString()}`}
          sx={{
            bgcolor: theme.palette.action.purpleDark,
            color: theme.palette.warning.contrastText,
            fontWeight: 500,
            fontFamily: theme.typography.fontFamily,
          }}
        />
      </Stack>

      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={completionPercent}
          size={140}
          thickness={5}
          sx={{ color: theme.palette.success.main }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h5"
            component="div"
            color={theme.palette.text.primary}
            fontWeight={600}
            fontFamily={theme.typography.fontFamily}
          >
            {`${completionPercent}%`}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
